import type { MutationFunctionOptions } from '@apollo/client';
import {
  type Exact,
  type Scalars,
  type StoreInsuranceMutation,
  useStoreInsuranceMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

type StoreInsuranceOptions = MutationFunctionOptions<
  StoreInsuranceMutation,
  Exact<{
    user_id: Scalars['Int']['input'];
    provider_type: Scalars['String']['input'];
    insured_amount: Scalars['Float']['input'];
    premium_amount: Scalars['Float']['input'];
    partner_premium_amount: Scalars['Float']['input'];
    insurance_period: Scalars['Int']['input'];
  }>
>;

export const useStoreInsurance = (options?: StoreInsuranceOptions) => {
  const [storeInsurance, { data, loading, error, reset }] =
    useStoreInsuranceMutation({
      context: {
        apiVersion: AppApiVersions.core,
      },
      ...options,
    });

  return {
    storedInsurance: data?.insurance,
    storeInsurance,
    isStoringInsurance: loading,
    errorStoringInsurance: error,
    resetStoredInsurance: reset,
  };
};
